module.exports = __webpack_public_path__ + "img/icon_my_team.818c393b.svg";